import React from 'react'
import {createRoot, type Root} from 'react-dom/client'
import {flushSync} from 'react-dom'
import {UIGame, type UIGameProps} from '@colonist/ui-game'
import {DefaultUIContextProvider, UserStateContextProvider} from '@colonist/ui'
import {getUIContextValue, getUserStateContextValue} from '../GetContextValues.ts'

let reactRoot: Root | null = null

export const renderUIGame = (props: UIGameProps) => {
    const {gameManager} = props
    let container = document.getElementById('ui-game') as HTMLDivElement | null
    if(container && reactRoot) {
        reactRoot.unmount()
        reactRoot = null
    }
    if(!container) {
        container = document.createElement('div')
        container.id = 'ui-game'
        container.style.pointerEvents = 'none'
        container.style.position = 'absolute'
        container.style.left = gameManager.canvasController.app.view.style.left
        container.style.width = gameManager.canvasController.appW + 'px'
        container.style.height = gameManager.canvasController.appH + 'px'
        document.body.appendChild(container)
    }

    const uiContextValue = getUIContextValue()
    const userStateContextValue = getUserStateContextValue()

    reactRoot = createRoot(container)
    // TODO remove flushSync when everything migrated to React
    // flushSync was added because the UIGame still significantly depends on UIGameManager
    // Especially, in Replay when changing the Player's perspective, we re-render the entire UIGame.
    // We will be able to remove flushSync only when UIGame is rendered once (UIGameManger.buildGame() is not expected to be called again)
    flushSync(() => {
        reactRoot?.render(<DefaultUIContextProvider {...uiContextValue}>
            <UserStateContextProvider {...userStateContextValue}>
                <UIGame {...props}/>
            </UserStateContextProvider>
        </DefaultUIContextProvider>)
    })
}
